'use strict';

Object.defineProperty(exports, "__esModule", {
    value: true
});

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _Component2 = require('../../Component');

var _Component3 = _interopRequireDefault(_Component2);

var _main = require('../templates/main');

var _main2 = _interopRequireDefault(_main);

var _item = require('../templates/item');

var _item2 = _interopRequireDefault(_item);

var _propTypes = require('prop-types');

var _propTypes2 = _interopRequireDefault(_propTypes);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

var Main = function (_Component) {
    _inherits(Main, _Component);

    function Main() {
        var _ref;

        var _temp, _this, _ret;

        _classCallCheck(this, Main);

        for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {
            args[_key] = arguments[_key];
        }

        return _ret = (_temp = (_this = _possibleConstructorReturn(this, (_ref = Main.__proto__ || Object.getPrototypeOf(Main)).call.apply(_ref, [this].concat(args))), _this), _this.template = _main2.default, _temp), _possibleConstructorReturn(_this, _ret);
    }

    _createClass(Main, [{
        key: 'debitFilter',
        value: function debitFilter(card) {
            return !!card.get('payAvailable') && (
            // cards of other banks
            card.get('balance') === undefined || card.get('balance') && card.get('balance').toFloat() > 0);
        }
    }, {
        key: 'creditFilter',
        value: function creditFilter(card) {
            return !!card.get('receiveAvailable');
        }
    }, {
        key: '_processCard',
        value: function _processCard(cardList) {
            var result = [].concat(cardList);

            result = this._sort(result);
            result = this._filter(result);
            result = this._template(result);

            return result;
        }
    }, {
        key: '_sort',
        value: function _sort(list) {
            if (this.props.debit !== null && this.props.collection.sortBy) {
                return this.props.collection.sortBy.call({ models: list }, this.props.debit ? 'orderDebit' : 'orderCredit');
            } else {
                return list;
            }
        }
    }, {
        key: '_filter',
        value: function _filter(list) {
            // set default filter if card type is set
            if (this.props.filter === null && this.props.debit !== null) {
                return list.filter(this.props.debit ? this.debitFilter : this.creditFilter);
                // manual card filter
            } else if (typeof this.props.filter === 'function') {
                return list.filter(this.props.filter);
                // no filter
            } else {
                return list;
            }
        }
    }, {
        key: '_template',
        value: function _template(list) {
            var _this2 = this;

            // apply card template
            return list.map(function (card) {
                return _item2.default.call(_this2, card);
            });
        }

        /**
         * select default card if value is null
         * @private
         */

    }, {
        key: '_selectFirst',
        value: function _selectFirst() {
            var value = void 0,
                current = this.card.value,
                list = void 0;

            if (this.props.selectFirst && !current && current !== 0 && this.props.collection && this.props.collection.length) {
                list = this._filter(this.props.collection);
                value = list[0] && list[0].id;

                if (value) {
                    this.card.value = value;
                }
            }
        }
    }, {
        key: '_cardRef',
        value: function _cardRef(el) {
            if (typeof this.props.elementRef === 'function') {
                this.props.elementRef(el);
            }

            this.card = el;
            this._selectFirst();
        }
    }]);

    return Main;
}(_Component3.default);

Main.propTypes = {
    collection: _propTypes2.default.any,
    elementRef: _propTypes2.default.func,
    filter: _propTypes2.default.func,
    selectFirst: _propTypes2.default.bool,
    debit: _propTypes2.default.bool
};
Main.defaultProps = {
    placeholder: 'CARD_SELECT_CARD_PLACEHOLDER',
    emptyListPlaceholder: 'CARD_SELECT_CARD_EMPTY_PLACEHOLDER',
    // select first card by default
    selectFirst: false,
    // filter rule fn
    filter: null,
    // debit card list
    debit: null,
    // card DropDown processor
    processor: null,
    collection: []
};
Main.displayName = 'CardSelect';
exports.default = Main;